import React from 'react';
import classNames from 'classnames'
import { ParallaxProvider, ParallaxBanner } from 'react-scroll-parallax';
import _ from 'underscore'
// import Desktop from './components/Desktop'
// import Mobile from './MobileApp.js'
import Header from './components/Header'
import Footer from './components/Footer'
import MobileFooter from './components/MobileFooter'
import LegalSnackbar from './components/LegalSnackbar'
import SectionContent from './components/SectionContent'
import ctaArrow from  './images/cta-arrow.svg'
import ctaPlay from  './images/cta-play.svg'

import {
  content,
} from './constants/content'
import scrollIndicator from  './images/scroll-indicator.svg'
import './App.scss'

// window.mobileCheck = function() {
//   let check = false;
//   (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
//   return check;
// };


const HEADER_HEIGHT = 64
const gtag_SAFE = (...args) => {
  try {
    window.gtag(...args);
  } catch (thrown) {
    console.error(thrown);
  }
};
// class App extends React.Component {
//
//
//   render() {
//     // console.log(window.mobileCheck());
//     return (
//       window.mobileCheck() ? <Mobile/> : <Desktop/>
//     );
//   }
//
// }
//
// export default App;

const gra = function(min, max) {
  return Math.random() * (max - min) + min;
}
function loop() {
  var elementsToShow = document.querySelectorAll('.show-on-scroll');
    // console.log('elements to show', elementsToShow)
    var scroll = window.requestAnimationFrame ||
  // IE Fallback
  function(callback){ window.setTimeout(callback, 1000/60)};
  Array.prototype.forEach.call(elementsToShow, function(element){
    if (isElementInViewport(element)) {
      element.classList.add('is-visible');
    } else {
      element.classList.remove('is-visible');
    }
  });

  scroll(loop);
}


function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  return (
    (rect.top <= 0
    && rect.bottom >= 0)
    ||
    (rect.bottom >= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.top <= (window.innerHeight || document.documentElement.clientHeight))
    ||
    (rect.top >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight))
  );
}

const nextItem = (currentSlideNumber) => {
  var previousSlide = document.getElementsByClassName("background")[currentSlideNumber - 1];
  if(!previousSlide) return
  previousSlide.classList.remove("up-scroll");
  previousSlide.classList.add("down-scroll");
  console.log(SLIDE_LIST[currentSlideNumber]);
  gtag_SAFE('event', 'desktop_down_scroll', {
    event_category: 'engagement',
    event_label: SLIDE_LIST[currentSlideNumber]
  });

}

const SLIDE_LIST = ['header-video', 'built-for-progress', 'carbon-neutral', 'going-electric',
'charging-network',
'soy-seats',
'coffee-grounds',
'lower-emissions','footer']

const previousItem = (currentSlideNumber) => {
  var currentSlide = document.getElementsByClassName("background")[currentSlideNumber];
  if(!currentSlide) return
  currentSlide.classList.remove("down-scroll")
  currentSlide.classList.add("up-scroll");
}

const getIsMobile = () => {
  return window.matchMedia( "(max-width: 768px)" ).matches
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      25: false,
      50: false,
      75: false,
      90: false,
      legalTextOpen: false,
      currentSlideNumber: 0,
      isMobile: getIsMobile()
    };



  }

  componentDidMount() {
    window.addEventListener('resize', this.updateIsMobile)
    // Detect request animation frame
    document.addEventListener('scroll', this.trackScroll);


    //Mobile only
    this.prevScrollPos = window.pageYOffset
    document.addEventListener('scroll', this.handleScrollForMobileHeader);


    //Desktop only
    this.parallaxInit();
    gtag_SAFE('event', 'desktop_down_scroll', {
      event_category: 'engagement',
      event_label: SLIDE_LIST[0]
    });

    // Call the loop for the first time TODO: figure out what this does
    loop();


    let items = document.getElementsByClassName('section');
  	for (let i = 0; i < items.length; i++){
  		items[i].style.minHeight = gra(20,30) + 'vh';
  	}
    window.scrollTo(0, 0);
  	// cssScrollSnapPolyfill()
  }

  updateIsMobile = () => {
    const wasMobile = this.state.isMobile
    const isMobile = getIsMobile()
    this.setState({isMobile: getIsMobile()})

    if(wasMobile && !isMobile) {
      this.setState({currentSlideNumber: 0})
      window.scrollTo(0, 0);
      this.parallaxInit();
    }
  }

  handleScrollForMobileHeader = () => {
    var currentScrollPos = window.pageYOffset;
    if(!document.getElementById("header")) return


    if (this.prevScrollPos > currentScrollPos) {
      document.getElementById("header").style.top = "0";
    } else {
      document.getElementById("header").style.top = "-100%"//"-50px";
    }
    if (currentScrollPos === 0 || currentScrollPos < 0)  {
      document.getElementById("header").style.top = "0";
    }
    this.prevScrollPos = currentScrollPos;
  }

  trackScroll = () => {
    // console.log('TRACK SCORLL CALLED')
    try {
      const windowHeight = window.innerHeight || (document.documentElement || document.body).clientHeight
      const docheight = Math.max(
          document.body.scrollHeight, document.documentElement.scrollHeight,
          document.body.offsetHeight, document.documentElement.offsetHeight,
          document.body.clientHeight, document.documentElement.clientHeight
      )
      const scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop
      const trackLength = docheight - windowHeight
      const percent = Math.floor(scrollTop/trackLength * 100) // gets percentage scrolled (ie: 80 or NaN if tracklength == 0)

      let sendEvent = false;

      if(percent === 25 && !this.state[25]) sendEvent = true;
      else if(percent === 50 && !this.state[50]) sendEvent = true;
      else if(percent === 75 && !this.state[75]) sendEvent = true;
      else if(percent === 90 && !this.state[90]) sendEvent = true;

      if(sendEvent) {
        this.setState({[percent]: true})
        gtag_SAFE('event', 'scroll', {
          event_category: 'engagement',
          event_label: `${percent}%`
        });
      }
    } catch(e) {
      //scroll tracking error
    }
  }

  parallaxInit() {
    var ticking = false;
    var isFirefox = (/Firefox/i.test(navigator.userAgent));
    var isIe = (/MSIE/i.test(navigator.userAgent)) || (/Trident.*rv\:11\./i.test(navigator.userAgent));
    var scrollSensitivitySetting = 50; //Increase/decrease this number to change sensitivity to trackpad gestures (up = less sensitive; down = more sensitive)
    var slideDurationSetting = 600; //Amount of time for which slide is "locked"
    const backgroundEl = document.getElementsByClassName("background")
    if(!backgroundEl) return
    var totalSlideNumber = backgroundEl.length;

    const parallaxScroll = (evt) => {
      var delta;
      if (isFirefox) delta = evt.detail * (-120); //Set delta for Firefox
      else if (isIe) delta = -evt.deltaY; //Set delta for IE
      else delta = evt.wheelDelta; //Set delta for all other browsers

      if (ticking !== true) {
        if (delta <= -scrollSensitivitySetting) { //Down scroll
          ticking = true;
          if (this.state.currentSlideNumber !== totalSlideNumber - 1) {
            this.setState({
              currentSlideNumber:  this.state.currentSlideNumber + 1,
            })
            nextItem(this.state.currentSlideNumber);
          }
          slideDurationTimeout(slideDurationSetting);
        }
        if (delta >= scrollSensitivitySetting) { //Up scroll
          ticking = true;
          if (this.state.currentSlideNumber !== 0) {
            this.setState({
              currentSlideNumber:  this.state.currentSlideNumber - 1,
            })
          }
          previousItem(this.state.currentSlideNumber);
          slideDurationTimeout(slideDurationSetting);
        }
      }
    }
    function slideDurationTimeout(slideDuration) {
      setTimeout(function() {
        ticking = false;
      }, slideDuration);
    }
    // ------------- ADD EVENT LISTENER ------------- //
    var mousewheelEvent = isFirefox ? "DOMMouseScroll" : "wheel";
    window.addEventListener(mousewheelEvent, _.throttle(parallaxScroll, 60), false);
    // ------------- SLIDE MOTION ------------- //



  }

  trackClick = (eventName, eventLabel) => () => {
    // eslint-disable-next-line no-undef
    gtag_SAFE('event', eventName, {
      event_category: 'engagement',
      event_label: eventLabel
    });
  }

  handleDotClick = (id, index) => () => {
    // eslint-disable-next-line no-undef
    gtag_SAFE('event', 'dot_click', {
      event_category: 'engagement',
      event_label: id
    });
    document.querySelector(`#${id}`).scrollIntoView({ //for mobile
      behavior: 'smooth'
    });

    //for desktop
    if(!document.getElementsByClassName("background")) return

    if(index < this.state.currentSlideNumber) { //scrolling up TODO
      for(let i = this.state.currentSlideNumber; i >= index; i--) {
        var currentSlide = document.getElementsByClassName("background")[i];
        currentSlide.classList.remove("down-scroll")
        currentSlide.classList.add("up-scroll");
      }
    } else { //scrolling down - works
      for(let i = 0; i < index; i++) {
        var previousSlide = document.getElementsByClassName("background")[i];
        previousSlide.classList.remove("up-scroll");
        previousSlide.classList.add("down-scroll");

      }
    }
    this.setState({currentSlideNumber: index})

  }

  handleScrollIndicatorClick = () => {
    //Mobile
    const nextSectionId = content[1].id
    document.querySelector(`#${nextSectionId}`).scrollIntoView({
      behavior: 'smooth'
    })

    if(!document.getElementsByClassName("background")) return
    //Desktop
    for(let i = 0; i < 1; i++) {
      var previousSlide = document.getElementsByClassName("background")[i];
      if(previousSlide) {
        previousSlide.classList.remove("up-scroll");
        previousSlide.classList.add("down-scroll");
      }


    }
    this.setState({currentSlideNumber: 1})
  }


  handleCTAClick = (id) => () => {
      // eslint-disable-next-line no-undef
      gtag_SAFE('event', 'cta_click', {
        event_category: 'engagement',
        event_label: id
      });
    }

  renderMobileSections = () => {
    return (
      <>
        <ParallaxProvider>
          {content.map((obj, sectionIndex) => {

            // const hasFooterText = obj.finePrint || obj.ctaText
            return (
              <section
                key={obj.id}
                id={obj.id}
                className="section"
              >
                <ParallaxBanner
                  // className="bgImageParallax"
                  className="mobile-section-background-image"
                  layers={[
                    {
                      ...(obj.isVideo ? {children: (
                        <video
                          // className={obj.video}
                          autoPlay
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                          }}
                          loop
                          playsInline
                          preload="auto"
                          muted
                          // poster={img1}//"https://s3-us-west-2.amazonaws.com/s.cdpn.io/105988/boats-at-sea.jpg"
                          src={obj.backgroundImage}//"https://s3-us-west-2.amazonaws.com/s.cdpn.io/105988/boats-at-sea-720.mp4"//{obj.video}//"https://s3-us-west-2.amazonaws.com/s.cdpn.io/105988/boats-at-sea-720.mp4"
                        />
                      )} : {
                        image: obj.mobileBackgroundImage,
                      }),
                      amount: 0.1,//.2,
                      expanded: true,
                      props: {
                        style: {
                          backgroundPosition: 'center',
                          backgroundColor: 'black'
                        }
                      }
                    },
                  ]}
                  style={{
                    height: '103%',
                    backgroundColor: 'black',
                    margin: '-3px 0px'
                  }}
                  // disabled={true}
                  // styleOuter={{
                  //   top: -2
                  // }}
                >
                  {sectionIndex  === 0  &&  <img
                    onClick={this.handleScrollIndicatorClick}
                    src={scrollIndicator}
                    alt="v"
                    className="scroll-indicator"
                                            />
                  }
                  <SectionContent
                    sectionObj={obj}
                    isMobile={this.state.isMobile}
                    sectionIndex={sectionIndex}
                    onCTAClick={this.handleCTAClick(obj.id)}
                  />
                </ParallaxBanner>
              </section>
            )
          })}
        </ParallaxProvider>
        <MobileFooter trackClick={this.trackClick} />
      </>
    )
  }

  renderDesktopSections = () => {
    const showNavigationDots = this.state.currentSlideNumber !== 10 && this.state.currentSlideNumber > 0
    const increaseZ = this.state.currentSlideNumber === 9 ? {zIndex: 200} : {zIndex: 'unset'};
    return (
      <>
        <div className="desktop-container" style={{height: `calc(100vh - ${HEADER_HEIGHT}px)`, top: HEADER_HEIGHT}}>


          <div style={{position: 'fixed', left: 0, bottom: 0, zIndex: 200, width: '100%', top: HEADER_HEIGHT, display: showNavigationDots ? 'flex' : 'none'}}>
            {<div
              className="nav-dot-container"
             >
              {content.map((sectionDot, i) => {
                if(i === 0 ) return null
                return (
                  <div
                    key={sectionDot.id}
                    onClick={this.handleDotClick(sectionDot.id, i)}
                    className="nav-dot"
                    style={{backgroundColor: i === this.state.currentSlideNumber ? 'white' : 'unset'}} />
                )
              })}
            </div>
            }
            <div style={{position: 'absolute', bottom: 0, right: 0, width: 400}}>
              {content.map((sectionDot, i) => {
                if(i === 0 ) return null
                const {
                    currentSlideNumber
                } = this.state;
                  const isPreviousSlide = currentSlideNumber - 1 === i
                  const isCurrentSlide = i === currentSlideNumber
                  const isNextSlide = currentSlideNumber + 1 === i
                if(!isPreviousSlide && !isCurrentSlide && !isNextSlide) return null
                return (
                    sectionDot.ctaText &&
                      <a
                        key={`cta-text-${i}`}
                        className={classNames("typography", "footer-cta", "footer-cta-fixed", {
                          "footer-cta-fixed-in": isCurrentSlide,
                          "footer-cta-fixed-out": !isCurrentSlide
                        })}
                        style={{position: 'absolute', right: 0, bottom: 0, width: 400, textAlign: 'right', pointerEvents: isCurrentSlide ? 'all' : 'none'}}
                        target="_blank" rel="noopener noreferrer" href={sectionDot.ctaUrl}
                        onClick={this.handleCTAClick(sectionDot.id)}
                      >
                        {sectionDot.ctaText} {sectionDot.showPlayButton
                          ? <img src={ctaPlay} alt=">" className="cta-play" />
                          : <img src={ctaArrow} alt=">" className="cta-arrow" />
                        }
                      </a>

                )
              })}
            </div>

          </div>

          {content.map((obj, sectionIndex) => {
            return (
              <section
                key={obj.id}
                id={obj.id}
                className="background"
                style={{height: `calc(100vh - ${HEADER_HEIGHT}px)`}}
              >
                {sectionIndex  === 0  &&  <img
                  onClick={this.handleScrollIndicatorClick}
                  src={scrollIndicator}
                  alt="v"
                  className="scroll-indicator"
                                          />
                }
                {obj.isVideo ? <video
                  // className={obj.video}
                  autoPlay
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    position: 'absolute'
                  }}
                  loop
                  playsInline
                  preload="auto"
                  muted
                  // poster={img1}//"https://s3-us-west-2.amazonaws.com/s.cdpn.io/105988/boats-at-sea.jpg"
                  src={obj.backgroundImage}//"https://s3-us-west-2.amazonaws.com/s.cdpn.io/105988/boats-at-sea-720.mp4"//{obj.video}//"https://s3-us-west-2.amazonaws.com/s.cdpn.io/105988/boats-at-sea-720.mp4"
                               />  : null}
                <SectionContent
                  sectionObj={obj}
                  isCurrentSlide={this.state.currentSlideNumber === sectionIndex }
                  isMobile={this.state.isMobile}
                  sectionIndex={sectionIndex}
                  onCTAClick={this.handleCTAClick(obj.id)}
                />
              </section>
            )
          })}
          <section className="background" style={{top: 0, overflow: 'auto', ...increaseZ}}>
            <Footer trackClick={this.trackClick} />
          </section>
        </div>

      </>
    )
  }

  render() {
    // console.log(window.mobileCheck());
    const {
      isMobile
    } = this.state;
    const renderHeader = isMobile || this.state.currentSlideNumber !== 9
    return (
      <div className={classNames( {
        'mobile-App': isMobile,
        'desktop-App': !isMobile
      })}>
        {renderHeader &&  <Header trackClick={this.trackClick}/> }
        {isMobile ? this.renderMobileSections() : this.renderDesktopSections()}
        {/* {ismobile ? <MobileFooter trackClick={this.trackClick} /> : <Footer trackClick={this.trackClick} />} */}

        <LegalSnackbar />
      </div>
    );
  }

}

export default App;
